import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ParticipantCardComponent } from './components/participant-card/participant-card.component';
import { SessionHandoffPageComponent } from './containers/session-handoff-page/session-handoff-page.component';
import { SessionHandoffEffects } from './store/effects/session-handoff.effects';
import { sessionHandoffReducer } from './store/reducers/session-handoff.reducer';
import { SharedModule } from '../shared';

@NgModule({
  declarations: [SessionHandoffPageComponent, ParticipantCardComponent],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('sessionHandoff', sessionHandoffReducer),
    EffectsModule.forFeature([SessionHandoffEffects]),
  ],
  exports: [SessionHandoffPageComponent],
})
export class SessionHandoffModule {}
